import $ from 'jquery';
import Flickity from 'flickity'

/**
 *
 * Setup Readmore Handler
 *
 */
function readmoreHandler() {
  const $trigger = $('.js-readmore-trigger');
  const readmoreActiveClass = 'readmore-active';
  const readmoreTriggerText = '.js-readmore-trigger-text';

  $trigger.on('click', (event) => {
    const $el = $(event.currentTarget);
    event.preventDefault();

    if ($el.hasClass(readmoreActiveClass)) {
      $el
        .removeClass(readmoreActiveClass)
        .prev()
        .slideUp(700);
      $el
        .find(readmoreTriggerText)
        .text('Read More')
    } else {
      $el
        .addClass(readmoreActiveClass)
        .prev()
        .slideDown(700);
      $el
        .find(readmoreTriggerText)
        .text('Read Less')
    }
  });
}

/**
 *
 * Initialises multiple Flickity Sliders
 *
 */
function initSlider() {
  const flickityElements = document.querySelectorAll('.js-init-flickity');

  for (let i = 0, len = flickityElements.length; i < len; i++) {
    const flickityElement = flickityElements[i];

    new Flickity(flickityElement, {
      watchCSS: true,
      pageDots: true,
      contain: true,
      freeScroll: false,
      dragThreshold: 10,
      selectedAttraction: 0.2,
      friction: 0.8,
      prevNextButtons: false
    });
  }
}

/**
 *
 * Opens the freshchat window
 *
 */
function freshChatTrigger() {
  $('[data-fc-launcher]').on('click', () => {
    if (typeof window.fcWidget === 'undefined') return;
    window.fcWidget.open();
  });
}

/**
 *
 * Trigger the smile window.
 * These buttons should have the smile query params
 * in the href as a fallback in case the JS isn't
 * loaded.
 *
 */
function smileTrigger() {
  $('#shopify-section-static-img-txt-rewards-2 .button-rewards').on('click', event => {
    if (typeof window.SweetTooth === 'undefined') return;
    event.preventDefault();
    SweetTooth.intent('st:points:rewards');
  });

  $('#shopify-section-static-img-txt-rewards .dynamic-column:nth-child(2) .button').on('click', event => {
    if (typeof window.SweetTooth === 'undefined') return;
    event.preventDefault();
    SweetTooth.intent('st:referrals:offers');
  });

  $('[data-smile-launcher]').on('click', event => {
    if (typeof window.SweetTooth === 'undefined') return;
    event.preventDefault();
    const target = event.currentTarget.getAttribute('href').split('=').pop();
    SweetTooth.intent(target);
  });
}

export {
  readmoreHandler,
  freshChatTrigger,
  smileTrigger,
  initSlider
}